import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApplicationConfigService } from '../../core/config/application-config.service';
import { GitlabGroup, GitlabProject } from '../model/gitlab.model';
import { createRequestOption, Search, SearchWithPagination } from '../utils/request-util';



@Injectable({ providedIn: 'root' })
export class GitlabService {
    private resourceUrl = "api/gitlab";

    constructor(
        private http: HttpClient,
        private applicationConfigService: ApplicationConfigService
    ){}

    getOwnedProjects(req?: SearchWithPagination) : Observable<HttpResponse<GitlabProject[]>> {
        const options = createRequestOption(req);
        return this.http.get<GitlabProject[]>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/projects`, { params: options, observe: 'response' });
    }

    getGroup(sectorsId: number, groupSearch: string): Observable<HttpResponse<GitlabGroup>> {
        let options: HttpParams = new HttpParams();
        options = options.set('groupSearch', groupSearch);
        return this.http.get<GitlabGroup>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/sectors/${sectorsId}/subgroups`, { params: options, observe: 'response' });
    }

    searchGroups(sectorsId: number, groupSearch: Search): Observable<HttpResponse<GitlabGroup[]>> {
        const options = createRequestOption(groupSearch);
        return this.http.get<GitlabGroup[]>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/sectors/${sectorsId}/subgroups-search`, { params: options, observe: 'response' });
    }
}